import styled, { css } from 'styled-components';
import { Colors, Breakpoints } from 'styles/Constants';
import { Table as BaseTable, Th as BaseTh, Tr, Td } from 'components/Table';
import { StyledTooltipWrapper } from 'components/TooltipWrapper/StyledTooltipWrapper';

export { BaseTable as Table, BaseTh as Th };

const Padding60 = css`
  @media (min-width: ${Breakpoints.small}) {
    padding-right: 60px;
  }
`;

export const StyledTable = styled(BaseTable)`
  @media (max-width: ${Breakpoints.medium}) {
    display: none;
  }
`;

export const Row = styled(Tr)<{ activeRow?: boolean }>`
  svg.trophy.gold {
    fill: ${Colors.gold};
    stroke: ${Colors.gold};
  }

  svg.trophy.silver {
    fill: ${Colors.silver};
    stroke: ${Colors.silver};
  }

  svg.trophy.bronze {
    fill: ${Colors.bronze};
    stroke: ${Colors.bronze};
  }

  ${({ activeRow }) =>
    activeRow &&
    css`
      background-color: ${Colors.primaryDarkBlue} !important;
      color: #ffffff;

      /* Usar selectores de clase en lugar de referencias de componentes */
      td:first-child {
        p {
          font-weight: 700;
          color: #ffffff;
        }
      }

      td {
        color: #ffffff;
      }

      ${StyledTooltipWrapper} {
        color: #ffffff;
        svg[name='warning'],
        svg[name='warning']:hover {
          stroke: #ffffff;
          fill: #ffffff;
        }
      }
    `}

  @media only screen and (max-width: ${Breakpoints.medium}) {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    text-align: center;
  }
`;

export const PositionColumn = styled(Td)`
  div.id {
    align-items: center;
    display: flex;
  }

  img.user-photo {
    border-radius: 100%;
    margin: 0 10px 0 25px;
    height: 50px;
    width: 50px;

    @media (min-width: ${Breakpoints.small}) {
      margin-left: 50px;
    }
  }

  p {
    color: ${Colors.primaryDarkBlue};
    font-weight: 700;
    margin: 1px 0 0 0;

    @media (min-width: ${Breakpoints.medium}) {
      font-size: 1.5rem;
    }
  }

  svg[name='warning'] {
    stroke: ${Colors.secondaryDarkGrey};
    fill: ${Colors.secondaryDarkGrey};

    &:hover {
      stroke: #fcba03;
      fill: #fcba03;
    }
  }
`;

export const TrophyColumn = styled(Td)`
  span.trophy {
    box-shadow: none;
  }

  svg.trophy {
    stroke-width: 20px;
    stroke: #d4d4d4;
    fill: #d4d4d4;
  }

  ${Padding60};
`;

export const Column = styled(Td)`
  ${Padding60};

  &.no-padding {
    padding: 0;
  }

  @media (max-width: ${Breakpoints.medium}) {
    text-align: left;
  }
`;

export const UserNameHeader = styled(BaseTh)`
  ${Padding60};
`;

export const PointsHeader = styled(BaseTh)`
  text-align: center;
  @media (min-width: ${Breakpoints.small}) {
    padding: 0px;
  }
`;

export const MobileCard = styled.div<{ activeCard?: boolean }>`
  display: none;

  @media (max-width: ${Breakpoints.medium}) {
    display: flex;
    align-items: center;
    padding: 15px;
    margin-bottom: 10px;
    border-radius: 8px;
    background-color: ${props =>
      props.activeCard ? Colors.primaryDarkBlue : '#ffffff'};
    color: ${props => (props.activeCard ? '#ffffff' : 'inherit')};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
`;

export const MobilePosition = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;

  .position {
    font-weight: 700;
    font-size: 1.2rem;
    color: ${Colors.primaryDarkBlue};
    min-width: 25px;
  }

  img.user-photo {
    border-radius: 100%;
    height: 40px;
    width: 40px;
    margin: 0 10px;
  }
`;

export const MobileTrophy = styled.div`
  margin-left: 10px;

  svg.trophy {
    width: 20px;
    height: 20px;

    &.gold {
      fill: ${Colors.gold};
      stroke: ${Colors.gold};
    }

    &.silver {
      fill: ${Colors.silver};
      stroke: ${Colors.silver};
    }

    &.bronze {
      fill: ${Colors.bronze};
      stroke: ${Colors.bronze};
    }
  }
`;

export const MobileInfo = styled.div`
  flex: 1;

  .employee-name {
    font-weight: 600;
    margin-bottom: 5px;
    font-size: 0.9rem;
  }
`;

export const MobilePoints = styled.div`
  display: flex;
  align-items: center;

  .points-label {
    font-size: 0.8rem;
    margin-right: 5px;
    opacity: 0.8;
  }

  .points-value {
    font-weight: 700;
    font-size: 1rem;
  }

  ${StyledTooltipWrapper} {
    display: flex;
    align-items: center;
  }
`;
